import isEqual from 'lodash/isEqual';
import { COLLECTION_ID } from '../../enums';
import { ApiClient } from './ApiClient';
import { CouponsApi } from './couponsApi';
import { mapDataToCommonFormat } from './couponsDiscountApi';
import { DiscountsApi } from './discountsApi';

// query: {
//   filter: {}
// },

const getIsPending = date => Number(date) > Date.now();
const getIsExpired = date => Number(date) < Date.now();
export const DataItemApi = (instance, httpClient) => {
  const apiClient = new ApiClient(httpClient);
  async function updateDataItem(campaignId, data, Apis) {
    var _response$dataItem;
    const url = `${Apis.data_items_url}/${campaignId}`;
    const body = {
      dataCollectionId: COLLECTION_ID.CAMPAIGNS,
      dataItem: {
        data
      }
    };
    const response = await apiClient.performAPIRequest({
      requestPromise: apiClient.put(url, instance, body),
      context: 'updateDataItem'
    });
    return (_response$dataItem = response.dataItem) != null && _response$dataItem.id ? response.dataItem : {};
  }
  async function queryDataItem(id, Apis) {
    if (!id) {
      return [];
    }
    console.log('>>> queryDataItem', id);
    const url = Apis.data_items_query_url;
    const filter = {
      filter: {
        _id: id
      }
    };
    const body = {
      dataCollectionId: COLLECTION_ID.CAMPAIGNS,
      query: {
        ...filter
      }
    };
    try {
      var _response$pagingMetad, _response$dataItems;
      const response = await apiClient.performAPIRequest({
        requestPromise: apiClient.post(url, instance, body),
        context: 'queryDataItem',
        isArr: true
      });
      const isNotEmpty = (((_response$pagingMetad = response.pagingMetadata) == null ? void 0 : _response$pagingMetad.count) ?? 0) >= 1;
      const dataItem = (_response$dataItems = response.dataItems) == null ? void 0 : _response$dataItems[0];
      if (isNotEmpty && dataItem) {
        await updateAfterQuery(response, Apis);
        return dataItem;
      } else {
        return {};
      }
    } catch (error) {
      return {};
    }
  }
  async function queryDataItems(_ref, Apis) {
    var _response$pagingMetad2;
    let shouldUpdate = _ref.shouldUpdate,
      singleItemId = _ref.singleItemId;
    const url = Apis.data_items_query_url;
    let filter;
    if (singleItemId) {
      filter = {
        filter: {
          _id: singleItemId
        }
      };
    }
    const body = {
      dataCollectionId: COLLECTION_ID.CAMPAIGNS,
      query: {
        ...filter
      }
    };
    const response = await apiClient.performAPIRequest({
      requestPromise: apiClient.post(url, instance, body),
      context: 'queryDataItems',
      isArr: true
    });
    console.log('>>>>>>> BODY RES', {
      response
    });
    const isNotEmpty = ((_response$pagingMetad2 = response.pagingMetadata) == null ? void 0 : _response$pagingMetad2.count) > 0;
    if (isNotEmpty && shouldUpdate) {
      await updateAfterQuery(response, Apis);
      const updatedRes = await queryDataItems({
        shouldUpdate: false
      }, Apis);
      return updatedRes;
    } else {
      return isNotEmpty ? response.dataItems : [];
    }
  }
  async function updateAfterQuery(response, Apis) {
    const clonedRes = JSON.parse(JSON.stringify(response));
    try {
      clonedRes.dataItems = await updateDataItemStatus(clonedRes.dataItems, Apis);
    } catch (e) {
      console.log('>>> updateDataItemStatus catch', e.message);
    }
    try {
      clonedRes.dataItems = await updateDataItemOffering(clonedRes.dataItems, instance, Apis);
    } catch (e) {
      console.log('>>> updateDataItemOffering catch', e.message);
    }
    console.log('>>> updateDataItemOffering success');
  }
  async function updateDataItemOffering(dataItems, instance, Apis) {
    const isCouponArr = ['coupon', 'membership_coupon'];
    const isAutomaticDiscountArr = ['automatic_discount'];
    const updatedDataItems = await Promise.all(dataItems.map(async dataItem => {
      const dataItemClone = JSON.parse(JSON.stringify(dataItem.data));
      const isCoupon = isCouponArr.includes(dataItemClone.offeringType);
      const isAutomaticDiscount = isAutomaticDiscountArr.includes(dataItemClone.offeringType);
      if (!isCoupon && !isAutomaticDiscount) {
        return dataItem;
      }
      const updatedOfferingData = await getUpdatedOfferingData({
        type: isCoupon ? 'coupons' : 'discounts',
        id: dataItemClone.offeringId,
        instance,
        Apis
      });
      if (!isEqual(updatedOfferingData, dataItemClone.offeringData)) {
        const updatedDataItem = {
          ...dataItemClone,
          offeringData: updatedOfferingData
        };
        await updateDataItem(dataItem.id, updatedDataItem, Apis);
        return {
          id: dataItem.id,
          data: updatedDataItem
        };
      }
      return dataItem;
    }));
    return updatedDataItems;
  }
  async function getUpdatedOfferingData(_ref2) {
    let type = _ref2.type,
      id = _ref2.id,
      instance = _ref2.instance,
      Apis = _ref2.Apis;
    const apiCalls = {
      coupons: CouponsApi(instance, httpClient).getCoupon,
      discounts: DiscountsApi(instance, httpClient).queryDiscount
    };
    const couponDiscountData = await apiCalls[type](id, Apis);
    const updatedOfferingData = mapDataToCommonFormat[type](couponDiscountData);
    return updatedOfferingData;
  }

  // async function updateSingleDataItemStatus(
  //   dataItem: ICampaignDataItem,
  //   status: string
  // ) {
  //   const updatedData = JSON.parse(JSON.stringify(dataItem.data));
  //   updatedData.campaignStatus = status;
  //   return updateDataItem(dataItem.id, updatedData);
  // }

  // async function queryDataItem({
  //   campaignId,
  // }: {
  //   campaignId: string;
  // }): Promise<any> {
  //   const url = `${Apis.data_items_query_url}/${campaignId}`;
  //   const body = {
  //     dataCollectionId: COLLECTION_ID,
  //   };

  //   const filter = {
  //     id: campaignId,
  //   };

  async function updateDataItemStatus(dataItems, Apis) {
    const updatedDataItems = await Promise.all(dataItems.map(async dataItem => {
      const updatedData = JSON.parse(JSON.stringify(dataItem.data));
      const IsNoEnd = updatedData.campaignDateEnd === '';
      const isPending = getIsPending(updatedData.campaignDateStart);
      const isExpired = getIsExpired(updatedData.campaignDateEnd);
      if (IsNoEnd && !isPending) {
        return dataItem;
      }
      if (isPending) {
        updatedData.campaignStatus = 'pending';
      } else if (isExpired) {
        updatedData.campaignStatus = 'expired';
      }
      return updateDataItem(dataItem.id, updatedData, Apis);
    }));
    return updatedDataItems;
  }
  return {
    updateDataItem,
    queryDataItems,
    queryDataItem
  };
};
//# sourceMappingURL=dataItemApi.js.map